module.exports = __webpack_public_path__ + "img/icon_email.546c572e.png";